import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment } from 'react';
import { Pagination } from '@uswitch/spark.pagination';
import { Helmet } from 'react-helmet-async';
import { useDataSelector, useComponentMeta } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var numberToLink = function numberToLink(_ref) {
  var pathname = _ref.pathname;
  return function (number) {
    return number === 1 ? "".concat(pathname) : "".concat(pathname, "?page=").concat(number);
  };
};

var PaginationWrapped = function PaginationWrapped(props) {
  var total = props.total,
      page = props.page,
      limit = props.limit;
  var meta = useComponentMeta('pagination');
  var totalPages = Math.ceil(total / limit);
  var showFirstAndLastArrows = meta !== null && meta !== void 0 && meta.showFirstAndLastArrows ? meta.showFirstAndLastArrows : false;
  return _jsx(Fragment, {
    children: total > limit ? [_jsxs(Helmet, {
      children: [_jsx("link", {
        href: "".concat(props.origin).concat(numberToLink(props)(page)),
        rel: "canonical"
      }), page > 1 ? [_jsx("link", {
        rel: "prev",
        href: "".concat(numberToLink(props)(page - 1))
      }, "0"), _jsx("link", {
        rel: "first",
        href: "".concat(numberToLink(props)(1))
      }, "1")] : null, page < totalPages ? [_jsx("link", {
        rel: "next",
        href: "".concat(numberToLink(props)(page + 1))
      }, "0"), _jsx("link", {
        rel: "last",
        href: "".concat(numberToLink(props)(totalPages))
      }, "1")] : null]
    }, "0"), _jsx(Pagination, {
      currentPage: page,
      totalPages: totalPages,
      createPageUrl: numberToLink(props),
      showFirstAndLastArrows: showFirstAndLastArrows
    }, "1")] : null
  });
};

var PaginationConnected = function PaginationConnected(props) {
  var _location$query;

  var paginationLimit = useDataSelector(['meta', 'paginationLimit'], 12);
  var location = useDataSelector(['location']);
  var propsConnected = {
    limit: props.limit || paginationLimit,
    page: Number(location === null || location === void 0 ? void 0 : (_location$query = location.query) === null || _location$query === void 0 ? void 0 : _location$query.page) || 1,
    pathname: (location === null || location === void 0 ? void 0 : location.pathname) || '',
    origin: (location === null || location === void 0 ? void 0 : location.origin) || ''
  };
  return _jsx(PaginationWrapped, _objectSpread(_objectSpread({}, props), propsConnected));
};

export default PaginationConnected;
//# sourceMappingURL=index.js.map